import {
  AnnotationHighlightCommentModel,
  AnnotationHighlightModel,
  AnnotationSourcesEnum,
  AnnotationTypesEnum,
} from '../../models/api/annotationModel';
import {SelectionLocation} from '../domSelectionHelpers';

// Track the type of the thing we're annotating
export enum AnnotationEventTrackingSourcesEnum {
  EMAIL = 'email',
  COMMENT = 'comment',
}

export function buildHighlightAnnotation(location: SelectionLocation): AnnotationHighlightModel {
  const {startIndex, text} = location;
  return {
    type: AnnotationTypesEnum.HIGHLIGHT,
    startIndex,
    endIndex: startIndex + text.length,
    text,
    textBefore: location.textBefore,
    textAfter: location.textAfter,
    source: AnnotationSourcesEnum.LIGHT_BODY,
  };
}

export function buildHighlightCommentAnnotation(
  location: SelectionLocation,
): AnnotationHighlightCommentModel {
  const {startIndex, text} = location;
  return {
    type: AnnotationTypesEnum.HIGHLIGHT_COMMENT,
    startIndex,
    endIndex: startIndex + text.length,
    text,
    textBefore: location.textBefore,
    textAfter: location.textAfter,
  };
}

/** Test if the selection is fully contained within an annotation. */
export function isSelectionInsideAnnotation(
  location: SelectionLocation | undefined,
  annotations: ReadonlyArray<AnnotationHighlightCommentModel | AnnotationHighlightModel> | undefined,
) {
  if (!location || !annotations) {
    return false;
  }

  const {startIndex} = location;
  const endIndex = startIndex + location.text.length;

  return annotations.some(
    (annotation) => annotation.startIndex <= startIndex && annotation.endIndex >= endIndex,
  );
}

const ANNOTATIONS_PER_LOCATION_LIMIT = 3;
export function canLocationAcceptMoreAnnotations(
  location: SelectionLocation | undefined,
  annotations: ReadonlyArray<AnnotationHighlightCommentModel | AnnotationHighlightModel> | undefined,
) {
  if (!location || !annotations) {
    return false;
  }

  const {startIndex} = location;
  const endIndex = startIndex + location.text.length;

  const annotationsInLocation = annotations.filter(
    (annotation) => annotation.startIndex <= startIndex && annotation.endIndex >= endIndex,
  );

  return annotationsInLocation.length < ANNOTATIONS_PER_LOCATION_LIMIT;
}
